'use client';

import { type HTMLMotionProps, motion } from 'motion/react';

import { Slot, type WithAsChild } from '@/components/animate-ui/primitives/animate/slot';
import { cn } from '@/lib/utils';

type ButtonProps = WithAsChild<
  HTMLMotionProps<'button'> & {
    hoverScale?: number;
    tapScale?: number;
  }
>;

const Button = ({ hoverScale = 1.05, tapScale = 0.95, asChild = false, className, ...props }: ButtonProps) => {
  const Component = asChild ? Slot : motion.button;

  return (
    <Component
      whileTap={{ scale: tapScale }}
      whileHover={{ scale: hoverScale }}
      className={cn('cursor-pointer', className)}
      {...props}
    />
  );
};

export { Button, type ButtonProps };
